import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const SUDDEN_DEATH_MODE: ModeDescription = {
  mode: GameMode.SUDDEN_DEATH,
  title: 'Sudden Death',
  description: 'One mistake and it is over. High stakes.',
  icon: '💀',
};
